<template>
    <ContentOrLoading>
        <template v-if="!loading">
            <b-col cols="12" class="pl-0 pr-0">
                <FormInput label="Asunto" type="text" name="asunto" id="asunto" v-model="localComunicado.asunto" rules="required" />
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="fecha de envío">Fecha de envio</label>
                    <ValidationProvider name="fecha de envío" rules="required" v-slot="{ errors }">
                        <datetime
                            v-model="localComunicado.fecha_envio"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            :min-datetime="new Date().toISOString()"
                            type="datetime"
                            input-id="fecha_envio"
                            value-zone="CET"
                        />
                        <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="nombre">Listo para enviar</label>
                    <ValidationProvider name="enviar" rules="required" v-slot="{ errors }">
                        <select id="enviar" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-model="localComunicado.listo_para_enviar">
                            <option :value="0">No</option>
                            <option :value="1">Si</option>
                        </select>
                        <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="email">Enviar a:</label>
                    <ValidationProvider name="objetivo" rules="required" v-slot="{ errors }">
                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="objetivo" v-model="localComunicado.enviar_a">
                            <option :value="1" selected>Todos los abonados + emails alternativos</option>
                            <option :value="2">Todos los compradores de un evento</option>
                            <option :value="3">Una lista personalizada</option>
                        </select>
                        <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>

            <template v-if="localComunicado.enviar_a == 2">
                <b-col cols="12" class="pl-0 pr-0">
                    <div class="form-group">
                        <label for="provincias">Seleccionar evento</label>
                        <ValidationProvider name="evento">
                            <multiselect
                                placeholder="Eventos"
                                :options="eventos"
                                id="eventos"
                                label="name"
                                track-by="id"
                                v-model="localComunicado.evento_id"
                            />
                        </ValidationProvider>
                    </div>
                </b-col>
            </template>

            <template v-if="localComunicado.enviar_a == 3">
                <b-col cols="12" class="pl-0 pr-0">
                    <div class="form-group">
                        <label for="provincias">Seleccionar base</label>
                        <ValidationProvider name="base" rules="required" v-slot="{ errors }">
                            <multiselect
                                placeholder="Deportistas"
                                :options="bases"
                                :value="bases.id"
                                id="bases"
                                label="nombre"
                                track-by="id"
                                v-model="localComunicado.base"
                            />
                            <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
            </template>

            <b-col cols="12" class="pl-0 pr-0">
                <FormInput label="Título" type="text" name="titulo" id="titulo" v-model="localComunicado.titulo" rules="required" />
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="nombre">Contenido</label>
                    <ValidationProvider name="contenido" rules="required" v-slot="{ errors }">
                        <QuillEditor
                            ref="editorComunicado"
                            v-model="localComunicado.contenido"
                            :image-upload-url="uploadImageUrl"
                        />
                        <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
        </template>
    </ContentOrLoading>
</template>

<script setup>
    import { ref } from 'vue';
    import QuillEditor from '@/modules/ui/QuillEditor.vue';
    import { useFormEmail } from '@/composables/admin/comunicados/useFormEmail';

    const props = defineProps({
        comunicado: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    });

    const emit = defineEmits(['update:loading']);
    const editorComunicado = ref(null);

    const {
        eventos,
        bases,
        localComunicado,
        uploadImageUrl,
        getComunicado,
    } = useFormEmail(props, emit);

    function procesarEditoresQuill() {
        if (editorComunicado.value) {
            localComunicado.value.contenido = editorComunicado.value.processAndGetHTML();
        }

        return getComunicado();
    }

    defineExpose({
        procesarEditoresQuill,
        getComunicado,
    });
</script>
